import React from 'react';
import InfoStrip from './info-strip';
var ErrorStrip = function (_a) {
    var content = _a.content;
    return (React.createElement(InfoStrip, { level: "error", content: content }));
};
export default ErrorStrip;
